<script setup lang="ts">
import { KsUpdatePrompt } from '@siclop/kstone-vue';
import { usePwaUpdate } from '@/composables/usePwaUpdate';

/**
 * Toast déclenché par le service worker quand une nouvelle version est
 * disponible (needRefresh) ou que l'app est prête à fonctionner hors-ligne
 * (offlineReady, premier install).
 *
 * LA FENÊTRE VIENT DU PACKAGE. Elle était écrite ici, et une autre — différente
 * — dans Caissa, une troisième dans Grimoire, pour dire la même chose.
 * `KsUpdatePrompt` la rend une fois pour tous les sites : en bas au milieu, le
 * logo à gauche. Ce qui reste ici est ce qui appartient à The H'O — son logo,
 * ses phrases, et la hauteur de sa barre du bas ; ses couleurs sont posées avec
 * les autres jetons dans `assets/styles/main.scss`.
 */

const {
  needRefresh,
  offlineReady,
  updating,
  applyUpdate,
  dismissUpdate,
  dismissOfflineReady,
} = usePwaUpdate();
</script>

<template>
  <KsUpdatePrompt
    v-model="needRefresh"
    logo="/pwa-192x192.png"
    title="Mise à jour disponible"
    message="Une nouvelle version de The H'O est prête. Recharge pour bénéficier des dernières améliorations."
    confirm-text="Recharger"
    updating-text="Mise à jour…"
    later-text="Plus tard"
    :updating="updating"
    @confirm="applyUpdate"
    @dismiss="dismissUpdate"
  />

  <!--
    Le premier install ne se refuse pas : il n'y a rien à appliquer plus tard,
    seulement une bonne nouvelle à accuser. D'où le bouton unique.
  -->
  <KsUpdatePrompt
    v-model="offlineReady"
    logo="/pwa-192x192.png"
    title="Prêt hors-ligne"
    message="L'app est désormais utilisable hors-ligne pour les écrans que tu as déjà visités."
    confirm-text="OK"
    :dismissible="false"
    @confirm="dismissOfflineReady"
  />
</template>
